<script lang="ts" setup>
import type { RouteLocationRaw } from 'vue-router';

defineProps<{ helpLink?: RouteLocationRaw }>();
</script>

<template>
	<div class="flex items-center justify-between gap-1 px-4 py-3 empty:hidden">
		<slot>
			<DButton
				v-if="helpLink"
				:to="helpLink"
				target="_blank"
				icon="lucide:circle-question-mark"
				variant="soft"
				color="neutral"
				size="lg"
				class="rounded-full"
			/>
		</slot>
	</div>
</template>
